import {cloneDeep} from "lodash";
import {getString} from "Core/helpers/data";
import {AccountSettingsListItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {AccountSettingsListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new AccountSettingsListItemDataObject(
		getString(result, 'id'),
		getString(result, 'abmAccountId'),
		getString(result, 'name')
	);

	return result;
}

// @note There is no output function since list is read only.